import React from 'react';
import { Pagination } from './Pagination';

interface IPagePaginationProps {
	data: any;
	currentPage: number;
	setCurrentPage: (value: number) => void;
	pathname: string;
	numberPerPage?: string;
	setNumberPerPage?: (value: string) => void;
}

export const PagePagination = (props: IPagePaginationProps): JSX.Element => {
	const { data, currentPage, setCurrentPage, pathname, numberPerPage, setNumberPerPage } = props;

	return (
		<>
			<div className="d-none d-md-block">
				<Pagination
					pageNumber={data?.currentPage}
					totalItemCount={data?.count}
					pageCount={data?.totalPages}
					hasNextPage={data?.nextPage}
					hasPreviousPage={data?.prevPage}
					pageSize={data?.pageSize}
					currentPage={currentPage}
					setCurrentPage={setCurrentPage}
					pagesToShow={7}
					rootPath={pathname}
					numberPerPage={numberPerPage}
					setNumberPerPage={setNumberPerPage}
				/>
			</div>
			<div className="d-md-none">
				<Pagination
					pageNumber={data?.currentPage}
					totalItemCount={data?.count}
					pageCount={data?.totalPages}
					hasNextPage={data?.nextPage}
					hasPreviousPage={data?.prevPage}
					pageSize={data?.pageSize}
					currentPage={currentPage}
					setCurrentPage={setCurrentPage}
					pagesToShow={2}
					rootPath={pathname}
					numberPerPage={numberPerPage}
					setNumberPerPage={setNumberPerPage}
				/>
			</div>
		</>
	);
};
